
import AOS from 'aos'
import 'aos/dist/aos.css'
import { computed, defineComponent, inject, onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import FullorderForm from '@/components/Form/FullorderForm.vue'
import NavbarProgress from '@/components/Form/NavbarProgress.vue'
import NavbarSlider from '@/components/Form/NavbarSlider.vue'
import FavoriteDialog from '@/components/Form/FavoriteDialog.vue'
import BagsizeDialog from '@/components/Page/BagsizeDialog.vue'
import CopyLinkDialog from '@/components/Page/CopyLinkDialog.vue'
import MobileBagtypeDialog from '@/components/Form/MobileBagtypeDialog.vue'
import MobileGreenboardDialog from '@/components/Form/MobileGreenboardDialog.vue'
import MobileNameDialog from '@/components/Form/MobileNameDialog.vue'
import Overlay from '@/components/Page/Overlay.vue'
import Progressbar from '@/components/Form/Progressbar.vue'
import ThreeFullorder from '@/components/Three/ThreeFullorder.vue'
import RenderingFullorder from '@/components/Rendering/RenderingFullorder.vue'
import FavoriteButton from '@/components/Form/FavoriteButton.vue'
import ModeButton from '@/components/Page/ModeButton.vue'
import Instruction from '@/components/Page/Instruction.vue'
import { useStore } from '@/store'
import { PageActionTypes } from '@/store/modules/page/action-types'
import { FormActionTypes } from '@/store/modules/form/action-types'
import ModeDetermineService from '@/services/page/mode-determiner.service'
import PageResizeService from '@/services/page/page-resize.service'
import RenderingViewButtons from '@/components/Rendering/RenderingViewButtons.vue'
import EventFloatingButtons from '@/components/Event/EventFloatingButtons.vue'
import Sakura from '@/components/Event/Sakura.vue'
import * as UrlConstants from '@/constants/url-constants'

export default defineComponent({
  name: 'Store',
  components: {
    FullorderForm,
    NavbarProgress,
    NavbarSlider,
    FavoriteDialog,
    BagsizeDialog,
    MobileBagtypeDialog,
    MobileGreenboardDialog,
    MobileNameDialog,
    CopyLinkDialog,
    Overlay,
    Progressbar,
    ThreeFullorder,
    RenderingFullorder,
    FavoriteButton,
    ModeButton,
    Instruction,
    RenderingViewButtons,
    EventFloatingButtons,
    Sakura
  },
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const isThreeMode = computed(() => store.getters.isThreeMode)
    const isRenderingMode = computed(() => store.getters.isRenderingMode)
    const isBagLoaded = computed(() => store.getters.isBagLoaded)
    const configLoaded = computed(() => store.getters.configLoaded)
    let useThreeMode = ref(false)
    let isSakuraVisible = ref(false)
    const pageResizeService = new PageResizeService()

    AOS.init({ duration: 500 })

    // prettier-ignore
    const desktopTabs = reactive(['本体の色を選んでね', 'へりの色を選んでね', '糸の色を選んでね', 'ふたの裏を選んでね',
      'ポケットを選んでね', 'よこのししゅうを選んでね', 'ふたを選んでね', 'ふたの鋲を選んでね', '背中の色を選んでね', 'ネームししゅうを選んでね', 'タイプを選んでね', 'ご選択内容'])
    // prettier-ignore
    const mobileTabs = reactive(['本体の色', 'へりの色', '糸の色', 'ふたの裏',
      'ポケット', 'よこのししゅう', 'ふた', 'ふたの鋲', '背中の色', 'ネーム', 'タイプ', 'ご選択内容'])

    onMounted(() => {
      document.body.classList.add('event')
      const sakura = determineSakuraVisible()
      if (sakura) {
        document.body.classList.add('sakura')
      }
      const useThree = new ModeDetermineService().determineFullorder()
      useThreeMode.value = useThree
      isSakuraVisible.value = sakura
      store.dispatch(PageActionTypes.SET_THREE_MODE, useThree)
      pageResizeService.init()
    })

    // prettier-ignore
    watch(() => isThreeMode.value, (isThree) => {
      useThreeMode.value = isThree
    })

    // prettier-ignore
    watch(() => isRenderingMode.value, (isRendering) => {
      if (isRendering) {
        loadConfig()
      }
    })

    // prettier-ignore
    watch(() => isBagLoaded.value, (_) => {
      loadConfig()
    })

    function loadConfig() {
      if (configLoaded.value) {
        emitter.emit('updateConfig')
      } else {
        store.dispatch(FormActionTypes.LOAD_CONFIG, true)
      }
    }

    function determineSakuraVisible() {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.has(UrlConstants.sakura) && urlParams.get(UrlConstants.sakura) == 'true'
    }

    onUnmounted(() => {
      pageResizeService.dispose()
    })

    return {
      desktopTabs,
      mobileTabs,
      useThreeMode,
      isSakuraVisible
    }
  }
})
